module.exports = __webpack_public_path__ + "static/media/download-shared-files.24bf22c6.svg";